
























import Vue from 'vue'
import mixins from 'vue-typed-mixins'

import { Diff } from '@/utils'
import LikertScale from './Scale.vue'
import Localized from '@/components/Localized'
import IsScale from './IsScale'
import ElementMixin from '../ElementMixin'
import { checkCondition } from '@/utils'
import IsTranslation from '../IsTranslation'

export interface ScaleSettings {
  anchors?: {
    begin?: IsTranslation
    end?: IsTranslation
  }
  scale: IsScale
  required?: boolean | object
  reversed?: boolean | object
  disabled?: boolean | object
  variable: string
}

export default mixins(ElementMixin).extend({
  mixins: [ElementMixin],
  components: { LikertScale, Localized },
  computed: {
    isFirstToBeCompleted(): boolean {
      return this.scaleSettings.some(settings => this.scaleIsFirstToBeCompleted(settings))
    },
    scaleSettings(): ScaleSettings[] {
      if (this.scale) {
        return [
          {
            anchors: this.anchors,
            disabled: this.disabled,
            scale: this.scale,
            required: this.required,
            reversed: this.reversed,
            variable: this.variable,
          },
        ]
      } else {
        return this.scales
      }
    },
    someIsRequiredButEmpty(): boolean {
      return this.scaleSettings.some(
        e => this.scaleIsEmpty(e) && !this.scaleIsDisabled(e) && this.scaleIsRequired(e)
      )
    },
    someIsEmpty(): boolean {
      return this.scaleSettings.some(e => this.scaleIsEmpty(e) && !this.scaleIsDisabled(e))
    },
    computedLocale(): string {
      return this.locale || this.$i18n.locale
    },
  },
  methods: {
    scaleIsFirstToBeCompleted(settings: ScaleSettings): boolean {
      return settings.variable === this.firstEmptyRequiredVariable
    },
    scaleIsDisabled({ disabled }: ScaleSettings): boolean {
      return checkCondition(disabled, this.value)
    },
    scaleIsRequired({ required }: ScaleSettings): boolean {
      return checkCondition(required, this.value)
    },
    scaleIsReversed({ reversed }: ScaleSettings): boolean {
      return checkCondition(reversed, this.value)
    },
    scaleIsEmpty({ variable }: ScaleSettings): boolean {
      return this.value[variable] === undefined
    },
  },
  props: {
    anchors: {
      type: Object,
    },
    reversed: {
      default: false,
      type: Boolean,
    },
    scale: {
      type: Object as () => IsScale,
    },
    scales: {
      type: Array as () => ScaleSettings[],
      default() {
        return []
      },
    },
    tag: {
      default: 'div',
      type: String,
    },
    locale: {
      type: String,
    },
  },
})
